export const ids = [
	'totalJobs',
	'timePerJob',
	'myTimePerJob',
	'completedJobsByRequirements',
	'completedJobsByAssignee',
	'myCompletedJobsByAssignee',
	'completedJobsByDate',
	'bigRiverGeelongCompletedJobsByDate',
	'bedcCompletedJobsByDate',
	'featuresByClient',
	'workOverdue',
	'completedTransactionsMyReview',
	'completedTransactionsTeamReview',
	'completedTransactionsTeamMemberReview',
	'estimateOutcome',
	'estimateOutcomeTrx',
	'designTransactions',
	'usageReports',
] as const;

export const links = [
	'totaljobs',
	'timeperjob',
	'mytimeperjob',
	'completedjobsbyrequirements',
	'completedjobsbyassignee',
	'mycompletedjobsbyassignee',
	'completedjobsbydate',
	'bigrivercompletedjobsbydate',
	'bedccompletedjobsbydate',
	'featuresbyclient',
	'workoverdue',
	'completedtransactionsteamreview',
	'completedtransactionsmyreview',
	'completedtransactionsteammemberreview',
	'estimateoutcome',
	'estimateoutcometrx',
	'designtransactions',
	'usagereports',
] as const;
